import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpTintComponent from './adpTint.component';

let adpTintModule = angular.module('adpTint', [
  uiRouter
])

.component('adpTint', adpTintComponent)

.name;

export default adpTintModule;



// WEBPACK FOOTER //
// ./src/app/components/adpTint/adpTint.js